import { generateClassificationQueryForContributors } from "helpers/classification"
import { getIncludeNotHeldParameter, getQueryParameters, getUsageParameters, getSimulateActionsNode, getContributorDescriptors, getAnalyticsOutputParameter } from "./helpers"

export function compositionQuery(classifications, options = {}) {
  const analyticsOutputParameter = getAnalyticsOutputParameter(options)
  const includeNotHeldParameter = getIncludeNotHeldParameter(options)

  return `query (${getQueryParameters([analyticsOutputParameter, includeNotHeldParameter])}) {
    model (id: $modelId) {
      simulation: ${getSimulateActionsNode([analyticsOutputParameter])}{
        ${compositionQueryFragment(classifications, [includeNotHeldParameter])}
      }
    }
  }`
}

export function positionHoldingsQuery() {
  return `
    query (${getQueryParameters()}) {
      model(id: $modelId){
        simulation: ${getSimulateActionsNode()}{
          ${positionHoldingsQueryFragment()}
        }
      }
    }
  `
}

export function positionsDeltaQueryFragment() {
  return `positionsDelta {
    id
    assetClass
    modelProviderId
  }`
}

export function positionHoldingsQueryFragment() {
  return `
  positions {
    date
    equities {
      id {
        ticker
        mic
        figi
        bloombergTicker
        modelProviderId
        internalId
      }
      lotId
      economicExposure
      attributes {
        category
        value
      }
    }
    currencies {
      id
      economicExposure
      lotId
      attributes {
        value
        category
      }
    }
    swaps {
      id
      economicExposure
      lotId
      attributes {
        value
        category
      }
    }
    fixedIncome {
      id { isin }
      economicExposure
      lotId
      attributes {
        value
        category
      }
    }
    commodities {
      id
      economicExposure
      lotId
      attributes {
        value
        category
      }
    }
    indexes {
      id
      economicExposure
      lotId
      attributes {
        value
        category
      }
    }
    otherAssets {
      id
      economicExposure
      lotId
      attributes {
        value
        category
      }
    }
  }
  `
}

export function compositionQueryFragment(classifications, parameters = []) {
  return `composition ${getUsageParameters(parameters, true)} {
    gmv
    referenceEquity
    positions {
      ${getContributorDescriptors(true)}
      economicExposure: positionSetEconomicExposure
      isNotHeld: notHeld
      ${generateClassificationQueryForContributors("GICS", classifications)}
    }
  }
  percent: composition(scaleFormat: PERCENT_EQUITY_GMV ${getUsageParameters(parameters)}) {
    positions {
      ${getContributorDescriptors(true)}
      activePercentEquity: economicExposure
      positionPercentEquity: positionSetEconomicExposure
      basePercentEquity: baseEconomicExposure
    }
  }
  filters {
    long
    short
    assetClasses {
      value
      label
    }
    assetSubclasses {
      value
      label
    }
    currencies {
      value
      label
    }
    countries {
      value
      label
    }
    classifications {
      id
      options {
        value
        label
      }
    }
    positionAttributes {
      id
      options {
        value
        label
      }
    }
    tags {
      id
      options {
        value
        label
      }
    }
  }`
}

export function groupedCompositionQuery(classifications, options = {}) {
  const analyticsOutputParameter = getAnalyticsOutputParameter(options)
  const includeNotHeldParameter = getIncludeNotHeldParameter(options)
  return `query (${getQueryParameters([analyticsOutputParameter, includeNotHeldParameter], true)}) {
    model (id: $modelId) {
      simulation: ${getSimulateActionsNode([analyticsOutputParameter])}{
        ${groupedCompositionQueryFragment(classifications, [includeNotHeldParameter])}
      }
    }
  }`
}

export function groupedCompositionQueryFragment(classifications, parameters = []) {
  return `groupedComposition: composition${getUsageParameters(parameters, true)}{
    gmv
    referenceEquity
    compositionBy(groupBy: $groupBy, groupById: $groupById, classificationTier: $tier){
      id
      description
      baseEconomicExposure
      economicExposure: positionSetEconomicExposure
      contributors {
        ${getContributorDescriptors(true)}
        economicExposure: positionSetEconomicExposure
        isNotHeld: notHeld
        ${generateClassificationQueryForContributors("GICS", classifications)}
      }
    }
  }
  groupedPercent: composition(scaleFormat: PERCENT_EQUITY_GMV ${getUsageParameters(parameters)}) {
    compositionBy(groupBy: $groupBy, groupById: $groupById, classificationTier: $tier ){
      id
      activePercentEquity: economicExposure
      positionPercentEquity: positionSetEconomicExposure
      basePercentEquity: baseEconomicExposure
      contributors {
        ${getContributorDescriptors(true)}
        activePercentEquity: economicExposure
        positionPercentEquity: positionSetEconomicExposure
        basePercentEquity: baseEconomicExposure
      }
    }
  }`
}
